export default (api) => {
    return {
        index: options => api.get('schools', options),
        get: (school_id, options) => api.get('schools/' + school_id, options),
        store: (data, options) => api.post('schools', data, options),
        check: (data, options) => api.post('schools/check', data, options)
    }
}
